import { render } from "./FilterDocuments.vue?vue&type=template&id=6355c0ed&scoped=true&ts=true"
import script from "./FilterDocuments.vue?vue&type=script&lang=ts"
export * from "./FilterDocuments.vue?vue&type=script&lang=ts"

import "./FilterDocuments.vue?vue&type=style&index=0&id=6355c0ed&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6355c0ed"]])

export default __exports__